<template>
  <header v-if="isAuthenticated" class="fixed w-full top-0 z-50">
    <nav class="bg-gray-800 border-b border-primary/20">
      <div class="flex flex-wrap justify-between items-center px-4 py-2.5">
        <div class="flex items-center">
          <img src="@/assets/logo.png" class="h-8 mr-6" alt="RedTeam Logo" />
          
          <!-- Navigation Menu -->
          <div class="flex space-x-4">
            <router-link 
              to="/proposal/new" 
              class="text-gray-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
              active-class="bg-gray-900 text-white"
            >
              New Proposal
            </router-link>
            <template v-if="isAdmin">
              <router-link 
                to="/users" 
                class="text-gray-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
                active-class="bg-gray-900 text-white"
              >
                User Management
              </router-link>
              <router-link 
                to="/settings" 
                class="text-gray-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
                active-class="bg-gray-900 text-white"
              >
                Settings
              </router-link>
              <router-link 
                to="/admin/services"
                class="text-gray-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
              >
                Services
              </router-link>
            </template>
          </div>
        </div>

        <!-- User Menu -->
        <div class="flex items-center">
          <router-link 
            to="/profile" 
            class="text-gray-300 hover:text-white mr-4 flex items-center gap-2"
          >
            <span class="text-sm">{{ username }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd" />
            </svg>
          </router-link>
          <FwbButton 
            color="gray" 
            size="sm"
            @click="handleLogout"
            class="!bg-gray-600 hover:!bg-gray-700 rounded-lg font-medium px-4 py-2"
          >
            Logout
          </FwbButton>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { FwbButton } from 'flowbite-vue';
import { computed, watch, onMounted } from 'vue';

export default {
  name: 'Header',
  components: {
    FwbButton
  },
  setup() {
    const store = useStore();
    const router = useRouter();

    // Computed properties for reactive state
    const isAuthenticated = computed(() => store.getters.isAuthenticated);
    const isAdmin = computed(() => {
      const value = store.getters.isAdmin;
      return value;
    });
    const username = computed(() => store.state.user?.username);

    
    
    // Watch for state changes
    watch(() => store.state.user, (newUser) => {
      
    }, { immediate: true });

    const handleLogout = async () => {
      await store.dispatch('logout');
      router.push('/');
    };

    return {
      isAuthenticated,
      isAdmin,
      username,
      handleLogout
    };
  }
}
</script> 